/* ==========================================================================
   Searcher > Client > Validations
   ========================================================================== */
/* Modules */
function isValid(data) {
    return data !== null && data !== undefined;
}

function inputsHasError(instance) {
    const { origin, destination, accommodationInput } = instance;

    if (!origin || !destination || !accommodationInput) return false;

    const { error: originError } = origin.store.select('data');
    const { error: destinationError } = destination.store.select('data');
    const { error: accommodationError } = accommodationInput.store.select('data');

    return !(!originError && !destinationError && !accommodationError);
}

function errorManager(instance) {
    const { destination, calendarInput, accommodationInput, store = {} } = instance;

    /* Data store */
    const { hasError, componentError } = store.select('data');

    if (!hasError) return;

    switch (componentError) {
        case 'origin':
            destination.actions.disable();
            calendarInput.actions.disable();
            accommodationInput.actions.disable();
            break;
        case 'destination':
            calendarInput.actions.disable();
            accommodationInput.actions.disable();
            break;
        case 'accommodation':
            accommodationInput.actions.setError();
            break;
        default:
            calendarInput.actions.setError();
            break;
    }
}

function vaidateOrigin(instance) {
    const { store = {} } = instance;

    /* Data */
    const { origin } = store.select('data');

    if (!isValid(origin)) {
        instance.origin.actions.reset();
        instance.actions.setError({ message: '', component: 'origin' });
    }

    validateDestination(instance);
}

function validateDestination(instance) {
    const { store = {} } = instance;

    /* Data */
    const { destination, origin } = store.select('data');
    const { error, disabled } = instance.destination.store.select('data');

    if (!isValid(origin)) return;

    if (!isValid(destination)) {
        instance.actions.setError({ message: '', component: 'destination' });

        return;
    }

    if (error) instance.destination.actions.resetStatus();
    if (disabled) instance.destination.actions.enable();

    validateRoute(instance);
}

function validateRoute(instance) {
    const { calendarInput, accommodationInput } = instance;
    if (!calendarInput || !accommodationInput) return;

    /* Data */
    const { origin, destination } = instance.store.select('data');

    if (isValid(origin) && isValid(destination)) {
        instance.actions.removeError();
        calendarInput.actions.enable();
        accommodationInput.actions.enable();
    }

    validateCalendar(instance);
}

function validateCalendar(instance) {
    const { dates = [] } = instance.store.select('data');

    if (dates.length !== 2) {
        instance.actions.setError({ message: '', component: 'calendar' });
        return;
    }

    instance.calendarInput.actions.resetStatus();

    // instance.calendarInput.input
    instance.actions.removeError();
}

function validateAccommodation(instance) {
    const { accommodationInput, accommodation } = instance;
    if (!accommodationInput || !accommodation) return;

    const { error } = accommodation.store.select('data');

    if (error) {
        instance.actions.setError({ message: '', component: 'accommodation' });

        return;
    }

    /* accommodation success */
    accommodationInput.actions.resetStatus();
    instance.actions.removeError();
}

module.exports = {
    vaidateOrigin,
    validateDestination,
    validateRoute,
    validateCalendar,
    validateAccommodation,
    inputsHasError,
    errorManager
};
